import CarotekColors from "@carotek/utils/Colors";
import { productCarouselStyles } from "@insite/content-library/Widgets/Common/ProductCarousel";
import { css } from "styled-components";

Object.assign(productCarouselStyles, {
    ...productCarouselStyles,
    titleText: {
        variant: "h3",
        css: css`
            text-align: center;
            margin-bottom: 10px;
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            margin-bottom: 70px;
        `,
    },
    carouselProductStyles: {
        productBrandStyles: {
            nameText: {
                css: css`
                    font-weight: normal;
                    text-align: center;
                    margin-bottom: 20px;
                    margin: 20px 0 25px;
                    :hover {
                        text-decoration: underline;
                    }
                `,
            },
            nameLink: {
                css: css`
                    text-align: center;
                    margin: 20px 0 25px;
                `,
                typographyProps: {
                    color: "text.link",
                    weight: "normal",
                    css: css`
                        :hover {
                            text-decoration: underline;
                        }
                    `,
                },
            },
        },
        productDescriptionStyles: {
            productDetailLink: {
                typographyProps: {
                    color: "text.link",
                    weight: "bold",
                    css: css`
                        :hover {
                            text-decoration: underline;
                        }
                    `,
                },
            },
        },
        productImageStyles: {
            img: {
                css: css`
                    width: 160px;
                    height: 160px;
                    margin: 0 auto;
                `,
            },
        },
        productAddToListLinkStyles: {
            link: {
                css: css`
                    margin-top: 15px !important;
                    border: 0;
                    width: 100%;
                    display: inline-block;
                    padding-top: 0.3rem;
                    padding-right: 2rem;
                    padding-bottom: 0.65rem;
                    padding-left: 2rem;
                    margin: 0 0 1rem;
                    background: ${CarotekColors.blue5} !important;
                    text-align: center;
                    :hover {
                        background-color: ${CarotekColors.grey15} !important;
                        border-color: ${CarotekColors.grey15} !important;
                    }
                `,
                typographyProps: {
                    css: css`
                        line-height: 17px;
                        text-decoration: none;
                        font-family: neuronBold !important;
                        text-transform: uppercase;
                        font-size: 18px;
                        color: ${CarotekColors.white} !important;
                    `,
                },
            },
        },
    },
});
